module.exports = __webpack_public_path__ + "static/media/case3.ad2a2cf0.png";